import "./Partners.module.css";
import Header from "@/reusable_sections/Header";
import AgentReferralProgram from "./sections/AgentReferralProgram";
import Footer from "@/reusable_sections/Footer";
export default function PartnersPage() {
  return <div>
      <Header />
      <AgentReferralProgram />
      <Footer />
    </div>;
}